import styled from 'styled-components'
import TextField, {FieldTwoInput} from 'components/field'

const styles = props => ({
  'margin-bottom': props.marginBottom || props.theme.form.marginBottom || '4px',
  'background-color': props.theme.form.fieldBackground,
  padding: props.theme.form.padding,
  cursor: 'auto',
})

const FormField = styled(TextField)([], styles)
const FormTwoInputField = styled(FieldTwoInput)([], styles)

export {FormTwoInputField, FormField}
